export default __webpack_public_path__ + "static/media/researchdevelopment.fbb2e228.jpg";